import request from '@/auth/request.js'
import {
    cbamService
} from '@/api/_proxy.config.js';


// 查询字典
// 查询全部字典初始化数据
const getAllDictInitData = params => getAction('/dict/getAllDictInitData', params);
// 询CN Code
const queryDictCncodeContrastList = params => postAction('/dict/queryDictCncodeContrastList', params);
// 查询原材料产品类型
const queryDictIndustryContrastList = params => postAction('/dict/queryDictIndustryContrastList', params);

const getDic = code => getDicAction('/dictCode/getDict/', code);

const getRoutes = params => postAction('/dictCode/getRoutes', params);


// post
export function postAction(url, parameter) {
    console.log(url);
    console.log(parameter);
    return request.post(cbamService(url), parameter, {headers: {'Content-Type': 'application/json;charset=UTF-8'}});
}

// get
function getAction(url, parameter) {
    return request.get(cbamService(url), parameter, {headers: {'Content-Type': 'application/json;charset=UTF-8'}});
}

// getDic

function getDicAction(url,code) {
    return request.get(cbamService(url)+code, {headers: {'Content-Type': 'application/json;charset=UTF-8'}});
}

export {
    getAllDictInitData,
    queryDictCncodeContrastList,
    queryDictIndustryContrastList,
    getDic,
    getRoutes
}

